import React from "react"
import { Container } from "@mui/material"
import { Navigate, Route, Routes } from "react-router-dom"
import DashboardPage from "@/features/dashboard/components/DashboardPage"
import MyListings from "@/features/listings/components/MyListings"
import ProfilePage from "@/features/profile/components/ProfilePage"
import GalleryPage from "@/features/gallery/components/GalleryPage"
import AboutPage from "@/features/about/components/AboutPage"
import BulkEditPage from "@/features/bulkedit/components/BulkEdit"
import AmazonCalculatorPage from "@/features/profit-calculators/amazon-calculator/components/AmazonCalculatorPage"
import MeeshoCalculatorPage from "@/features/profit-calculators/meesho-calculator/components/MeeshoCalculatorPage"
import MonthlyReportsPage from "@/features/profit-calculators/calculator-shared/components/MonthlyReportsPage"
import ReportPage from "@/features/profit-calculators/calculator-shared/components/ReportPage"

type Props = {
  children?: React.ReactNode
}
const Home = (props: Props) => {
  return (
    <Container component="main" sx={{ paddingTop: 12 }}>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="my-listings" element={<MyListings />} />
        <Route path="gallery" element={<GalleryPage />} />
        <Route path="bulk-edit" element={<BulkEditPage />} />
        {/* <Route path="preview" element={<PreviewPage />} /> */}
        <Route path="meesho-calculator" element={<MonthlyReportsPage platform="meesho" />} />
        <Route path="meesho-calculator/chart" element={<MonthlyReportsPage platform="meesho" section="chart" />} />
        <Route path="meesho-calculator/:monthKey/upload" element={<MeeshoCalculatorPage />} />
        <Route path="meesho-calculator/:monthKey/report" element={<ReportPage platform="meesho" />} />
        <Route path="amazon-calculator" element={<MonthlyReportsPage platform="amazon" />} />
        <Route path="amazon-calculator/chart" element={<MonthlyReportsPage platform="amazon" section="chart" />} />
        <Route path="amazon-calculator/:monthKey/upload" element={<AmazonCalculatorPage />} />
        <Route path="amazon-calculator/:monthKey/report" element={<ReportPage platform="amazon" />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Container>
  )
}

export default Home
